import { useEffect, useState } from 'react';

// @mui
import { styled } from '@mui/material/styles';
import {
  Typography,
  Box,
  CircularProgress,
  Button,
  Switch,
  Stack,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@mui/material';
import { Menu } from '@mui/material';
import LeadsIcon from '../assets/svgs/leadsIcon';
import { KanbanView } from '../sections/kanban/view';
import CheckCircle from '@mui/icons-material/CheckCircle';
import { SnackbarProvider } from 'src/components/snackbar';
import { useLocation, useNavigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import pageTitle from '../utils/pageTitles.json';
import { checkButtonAccess } from 'src/utils/common';
import TableFilters from 'src/sections/kyc/tableFilter';
import ChipsProducts from '../sections/kanban/kanban-chip';
import { initialProducts } from '../utils/productList';
import BarChartIcon from '@mui/icons-material/BarChart';
import { button } from 'src/theme/overrides/components/button';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import LeadUsers from './LeadUsers';

import dayjs from 'dayjs';

// home main section container.
const MainSection = styled('div')(({ theme }) => ({
  padding: '64px 20px 20px 88px',
  backdropFilter: 'blur(6px)',
  backgroundColor: 'rgba(255, 255, 255, 0.8)',
}));

// Show home hading and filtes
const HeadingSection = styled('div')(() => ({
  width: '100%',
  padding: '20px 0px 20px 0px',
  display: 'flex',
  justifyContent: 'space-between',
  flexDirection: 'row',
}));

const HeadingContentSection = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '10px',
  alignItems: 'center',
  justifyContent: 'center',
}));
const RowBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  gap: '10px',
  width: '100%',
}));

const RowInnerBox = styled('div')(() => ({
  display: 'flex',
  flexDirection: 'column',
  width: 'calc(100%/2 - 5px)',
  gap: '5px',
}));

const Key = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  color: theme.palette.grey[600],
}));
const ConnectionIndicator = ({ isConnected }) => {
  const text = 'You are disconnected! Try again';

  return (
    <Box style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
      {isConnected === 'pending' && (
        <div style={{ marginRight: 8 }}>
          <CircularProgress size={18} sx={{ color: 'green' }} />
        </div>
      )}
      {isConnected === 'connected' && <CheckCircle sx={{ color: 'green', fontSize: 18 }} />}
      {
        isConnected === 'disconnected' && (confirm(text) == true ? window.location.reload() : window.location.reload())
        // <Error sx={{ color: 'red', fontSize: 18 }} />
      }

      <Box component="span" sx={{ fontWeight: 'bold' }}>
        {isConnected === 'pending' && 'Pending'}
        {isConnected === 'connected' && 'Connected'}
        {isConnected === 'disconnected' && 'Disconnected'}
      </Box>
    </Box>
  );
};

const AntSwitch = styled(Switch)(({ theme }) => ({
  width: 28,
  height: 16,
  padding: 0,
  display: 'flex',
  '&:active': {
    '& .MuiSwitch-thumb': {
      width: 15,
    },
    '& .MuiSwitch-switchBase.Mui-checked': {
      transform: 'translateX(9px)',
    },
  },
  '& .MuiSwitch-switchBase': {
    padding: 2,
    '&.Mui-checked': {
      transform: 'translateX(12px)',
      color: '#fff',
      '& + .MuiSwitch-track': {
        opacity: 1,
        backgroundColor: '#1890ff',
        ...theme.applyStyles('dark', {
          backgroundColor: '#177ddc',
        }),
      },
    },
  },
  '& .MuiSwitch-thumb': {
    boxShadow: '0 2px 4px 0 rgb(0 35 11 / 20%)',
    width: 12,
    height: 12,
    borderRadius: 6,
    transition: theme.transitions.create(['width'], {
      duration: 200,
    }),
  },
  '& .MuiSwitch-track': {
    borderRadius: 16 / 2,
    opacity: 1,
    backgroundColor: 'rgba(0,0,0,.25)',
    boxSizing: 'border-box',
    ...theme.applyStyles('dark', {
      backgroundColor: 'rgba(255,255,255,.35)',
    }),
  },
}));

const analysisDetails = async (navigate) => {
  navigate('/leads_analysis');
};

const Leads = () => {
  const [connect, setConnect] = useState('pending');
  const navigate = useNavigate();
  const [board, setBoard] = useState();
  const [ticketType, setTicketType] = useState('lead');
  const [isLoading, setIsLoading] = useState(true);
  const [leadTypeSwitch, setLeadTypeSwitch] = useState(true);
  const [searchValue, setSearchValue] = useState('');
  const [load, setLoad] = useState(false);
  const [products, setProducts] = useState(['Console', 'DeepCall', 'Sarv.com', 'Meet', 'In.inc','Naam.ai']);
  const location = useLocation();
  const [customDateFilter, setCustomDateFilter] = useState({ start: null, end: null });
  const [prevCustomDateFilter, setPrevCustomDateFilter] = useState({ start: null, end: null });

  const [filter, setFilter] = useState('last30Days');
  const [prevFilter, setPrevFilter] = useState('last30Days');

  const [dateAnchorEl, setDateAnchorEl] = useState(null);
  const [tempDateFilter, setTempDateFilter] = useState({ start: null, end: null });
  const [dateError, setDateError] = useState(false);
  const [sourceFilter, setSourceFilter] = useState('All');

  //   const handleChangeSelect = (event) => {
  //     setFilter(event.target.value);
  //   };

  useEffect(() => {
    console.log(checkButtonAccess('leads', 'r'), checkButtonAccess('support', 'r'));
    if (checkButtonAccess('leads', 'r') && checkButtonAccess('support', 'r')) {
      setTicketType('lead');
    } else if (checkButtonAccess('leads', 'r')) {
      setTicketType('lead');
      setLeadTypeSwitch(false);
    } else {
      setTicketType('support');
      setLeadTypeSwitch(false);
    }
    setIsLoading(false);
  }, []);

  useEffect(() => {
    setBoard({});
    const ticketTypeFromState = location?.state?.ticketType;
    if (ticketTypeFromState) {
      setTicketType(ticketTypeFromState);
    } else {
      setTicketType('lead');
    }
  }, [location?.state?.ticketType]);

  if (isLoading) {
    return <></>;
  }

  const handleChangeSearch = (value) => setSearchValue(value);

  const handleProductUpdate = (updatedProduct) => {
    setProducts(updatedProduct.map((item) => item.id));
  };

  const handleReset = () => {
    setSearchValue('');
  };

  const tableFilter = (
    <TableFilters
      search={searchValue}
      handleChange={handleChangeSearch}
      setLoad={setLoad}
      resetClick={searchValue ? handleReset : null}
      reset={searchValue ? 'Reset' : null}
    />
  );

  const productChip = <ChipsProducts initialChips={initialProducts} onChipUpdate={handleProductUpdate} />;
  const sourceFilterControl = (
    <FormControl size="small" sx={{ width: '150px' }}>
      <InputLabel id="source-filter-label">Lead Source</InputLabel>
      <Select
        labelId="source-filter-label"
        value={sourceFilter}
        label="leads Source"
        onChange={(event) => setSourceFilter(event.target.value)}
      >
        <MenuItem value="All">All</MenuItem>
        <MenuItem value="direct">Direct</MenuItem>
        <MenuItem value="google">Google</MenuItem>
      </Select>
    </FormControl>
  );
  const dateFilter = (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
      <FormControl size="small" sx={{ width: '200px' }}>
        <InputLabel id="date-filter-label">Date Filter</InputLabel>
        <Select
          labelId="date-filter-label"
          value={filter}
          label="Date Filter"
          onChange={(event) => {
            const value = event.target.value;
            setPrevFilter(filter);
            setFilter(value);

            if (value === 'custom') {
              setTempDateFilter(customDateFilter);
              setDateAnchorEl(document.getElementById('date-filter-label'));
            } else {
              setCustomDateFilter({ start: null, end: null });
            }
          }}
        >
          <MenuItem value={'today'}>Today</MenuItem>
          <MenuItem value={'yesterday'}>Yesterday</MenuItem>
          <MenuItem value={'thisWeek'}>This Week</MenuItem>
          <MenuItem value={'lastWeek'}>Last Week</MenuItem>
          <MenuItem value={'thisMonth'}>This Month</MenuItem>
          <MenuItem value={'lastMonth'}>Last Month</MenuItem>
          <MenuItem value={'last30Days'}>Last 30 Days</MenuItem>
          <MenuItem value={'last180Days'}>Last 180 Days</MenuItem>
          <MenuItem value={'last365Days'}>Last 365 Days</MenuItem>
          <MenuItem value={'allTime'}>All Time</MenuItem>
          <MenuItem
            value={'custom'}
            onClick={(event) => {
              setPrevFilter(filter);
              setPrevCustomDateFilter(customDateFilter);
              setFilter('custom');

              setTempDateFilter(customDateFilter);
              setDateAnchorEl(document.getElementById('date-filter-label'));
            }}
          >
            Custom
          </MenuItem>
        </Select>
      </FormControl>

      <Menu
        anchorEl={dateAnchorEl}
        open={Boolean(dateAnchorEl)}
        onClose={() => {
          setDateAnchorEl(null);
          if (!customDateFilter?.start || !customDateFilter?.end) {
            setFilter('allTime');
          }
        }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        sx={{
          '& .MuiPaper-root': {
            marginTop: '28px',
            marginLeft: '-15px',
          },
        }}
      >
        <Box sx={{ p: 2, width: 400 }}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <RowBox>
              <RowInnerBox>
                <Key>From</Key>
                <DatePicker
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: { width: '180px' },
                      error: dateError,
                      helperText: dateError ? 'Start date cannot be after end date!' : '',
                    },
                  }}
                  value={tempDateFilter.start}
                  onChange={(newValue) => {
                    const newStart = newValue;
                    const newEnd = tempDateFilter.end;
                    setDateError(newEnd && dayjs(newStart).isAfter(dayjs(newEnd)));
                    setTempDateFilter((prev) => ({
                      ...prev,
                      start: newValue,
                      ...(prev.end && dayjs(newValue).isAfter(dayjs(prev.end)) ? { end: null } : {}),
                    }));
                  }}
                />
              </RowInnerBox>
              <RowInnerBox>
                <Key>To</Key>
                <DatePicker
                  slotProps={{
                    textField: {
                      size: 'small',
                      sx: { width: '180px' },
                      error: dateError,
                      helperText: dateError ? 'End date cannot be before start date' : '',
                    },
                  }}
                  value={tempDateFilter.end}
                  minDate={tempDateFilter.start}
                  onChange={(newValue) => {
                    setDateError(dayjs(newValue).isBefore(dayjs(tempDateFilter.start)));
                    setTempDateFilter((prev) => ({ ...prev, end: newValue }));
                  }}
                  disabled={!tempDateFilter.start}
                />
              </RowInnerBox>
            </RowBox>
          </LocalizationProvider>
          <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 2 }}>
            <Button
              size="small"
              variant="contained"
              disabled={!tempDateFilter.start || !tempDateFilter.end || dateError}
              onClick={() => {
                setCustomDateFilter(tempDateFilter);
                setDateAnchorEl(null);
                setFilter('custom');
                setDateError(false);
              }}
            >
              Apply
            </Button>
          </Box>
        </Box>
      </Menu>
    </Box>
  );
  return (
    <>
      <Helmet>
        <title> {`${pageTitle?.leads}`} </title>
      </Helmet>
      <SnackbarProvider>
        <MainSection>
          {/* {leadTypeSwitch && (<Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
                        <Typography>Leads</Typography>
                        <Box sx={{ display: 'flex', justifyContent: 'center' }}>
                            <AntSwitch defaultChecked inputProps={{ 'aria-label': 'ant design' }} checked={ticketType === "support" ? true : false} onChange={handleChange} />
                        </Box>
                        <Typography>Support</Typography>
                    </Stack>)} */}
          {/* Heading and filters */}
          <HeadingSection>
            <HeadingContentSection>
              <Box
                sx={{
                  width: '16px',
                  height: '16px',
                  mt: '-10px',
                }}
              >
                <LeadsIcon />
              </Box>
              <Typography variant="h5" sx={{ color: 'grey.10', fontWeight: 600, marginLeft: '13px' }}>
                {ticketType === 'support' ? 'Support' : 'Leads'}
              </Typography>
            </HeadingContentSection>

            {ticketType === 'lead' && (
              <Box sx={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                <Box>{productChip}</Box>
                {sourceFilterControl}
                {dateFilter}
                <Box sx={{ marginRight: '10px' }}>{tableFilter}</Box>
                {ticketType === 'lead' && (
                  <Button variant="outlined" color="primary" onClick={() => analysisDetails(navigate)} size="small">
                    <BarChartIcon sx={{ margin: '6px' }} />
                    Leads Analysis
                  </Button>
                )}
                <LeadUsers leads={ticketType} />
                <ConnectionIndicator isConnected={connect} />
              </Box>
            )}
            {ticketType === 'support' && (
              <Box sx={{ marginRight: '130px' }}>
                <LeadUsers leads={'support'} />
              </Box>
            )}
          </HeadingSection>

          {/* <CardsSection /> */}

          <KanbanView
            setState={setConnect}
            ticketType={ticketType}
            board={board}
            setBoard={setBoard}
            searchValue={searchValue}
            products={products}
            filter={filter}
            customDateFilter={customDateFilter}
            prevFilter={prevFilter}
            prevCustomDateFilter={prevCustomDateFilter}
            sourceFilter={sourceFilter}
          />
        </MainSection>
      </SnackbarProvider>
    </>
  );
};
export default Leads;
